import React from "react";
import {Route} from "react-router-dom";


const module = (shopApp) => {
	const CheckoutSummary = shopApp.dynamic(() => import("./CheckoutSummary"));

	const url = "/checkout_summary";

	let config = {
		name: "CheckoutSummary",
		routes: [
			<Route key={url} exact path={url} component={CheckoutSummary}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
